import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getReferenceDataByDomain } from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";
import { ReferenceDataDomains } from "../../../../constants/referenceDataDomains";

const sliceName = "appData/foreignId";
const foreignIdSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(foreignIdThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(foreignIdThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(foreignIdThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const foreignIdThunk = createAsyncThunk(
  `${sliceName}/foreignIdThunk`,
  async () => {
    const response = await getReferenceDataByDomain(ReferenceDataDomains.FOREIGN_IDENTIFIER_TYPE)();
    return { data: response };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.foreignId);
    },
  },
);

export default foreignIdSlice.reducer;
